import { render, staticRenderFns } from "./OrderPanels.vue?vue&type=template&id=3f6df0a3&scoped=true"
import script from "./OrderPanels.vue?vue&type=script&lang=js"
export * from "./OrderPanels.vue?vue&type=script&lang=js"
import style0 from "./OrderPanels.vue?vue&type=style&index=0&id=3f6df0a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6df0a3",
  null
  
)

export default component.exports